
import React, { useState, createContext, useContext, useRef } from "react";
// import { QRCodeContext } from "./QRCodeProvider";

// import { MusicProvider } from '../context/MusicProvider';

// const Default_QR = require('../options_02.json')
// Create a new context
export const AppContext = createContext();

// Create a context provider component
export const AppProvider = ({ children }) => {
  // const { qrCodeData, updateQRCodeData } = useContext(QRCodeContext);
  const playerRef = useRef(null);
  const [appData, setAppData] = useState(false)
  const [userData, setUserData] = useState()
  const [transactions, setTransactions] = useState()
  const [musicOn, setMusicOn] = useState(false)
  const [showInterfaceText, setShowInterfaceText] = useState(false)
  const [interfaceText, setInterfaceText] = useState(false)
  const [actionError, setActionError] = useState(null)
  const [actionText, setActionText] = useState(null)
  const [currentFloor, setCurrentFloor] = useState('1')
  const [currentView, setCurrentView] = useState('cockpit')

  const [geoData, setGeoData] = useState(false)

  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [weather, setWeather] = useState({
    temp: "--",
    feelsLike: "--",
    conditionText: "Scanning...",
    windSpeed: 0,
    precipitation: 0,
    isSevere: false,
    severeReason: null,
  });

  const [playAudio, setPlayAudio] = useState()
  const [displayAudio, setDisplayAudio] = useState()
  const [isMusicPlaying, setIsMusicPlaying] = useState(false)
  const [artist, setArtist] = useState({})

  const togglePlay = () => {
    // playerRef.current.audio.current.muted = true
    playerRef?.current?.audio?.current?.play();
    setIsMusicPlaying(true)

  }
  const togglePause = () => {
    playerRef?.current?.audio?.current?.pause();
    setIsMusicPlaying(false)
  }


  const updateAppData = (newData) => {
    setAppData((prevState) => ({
      appData,
      userData,
      transactions,
      showInterfaceText,
      interfaceText,
      geoData,
      weather,
      musicOn,
      artist,
      actionError,
      currentFloor,
      currentView,
      actionText,
      isLoggedIn,
      //----Music State----
      playerRef,
      playAudio,
      displayAudio,
      isMusicPlaying,

      ...userData,
      ...prevState,
      ...newData,
    }));

  };


  return (
    <AppContext.Provider value={{
      appData,
      updateAppData,

      userData,
      setUserData,
      transactions,
      setTransactions,
      geoData,
      setGeoData,
      weather,
      setWeather,
      showInterfaceText,
      setShowInterfaceText,
      currentFloor,
      setCurrentFloor,
      currentView,
      setCurrentView,
      interfaceText,
      setInterfaceText,
      actionError,
      setActionError,
      actionText,
      setActionText,
      isLoggedIn,
      setIsLoggedIn,
      // ---MUSIC STATE----
      artist,
      setArtist,
      playerRef,
      musicOn,
      setMusicOn,
      playAudio,
      setPlayAudio,
      displayAudio,
      setDisplayAudio,
      isMusicPlaying,
      setIsMusicPlaying,
      togglePause,
      togglePlay

    }}>

      {children}
    </AppContext.Provider>
  );
};
export const AppState = () => {
  return useContext(AppContext);
};